export const checkValueDecimalsCount = (
  value: number | string,
  decimals = 2,
) => {
  if (typeof value === "number" && value >= Number.MAX_SAFE_INTEGER) {
    throw new Error("not support");
  }

  const [v, afterPoint] = `${value}`.split(/[.,]/gi);
  return {
    afterPoint,
    check: afterPoint ? afterPoint.length <= decimals : true,
    value: v,
  };
};
